import { Registration, Merchant } from '@stax-core/types-omni';

export const booleanOptions = [
  { key: '1', description: 'Yes' },
  { key: '0', description: 'No' },
];

// prettier-ignore
export const refundPolicies: { key: Registration['refund_policy']; description: string }[] = [
  { key: 'N', description: 'No Refunds' },
  { key: 'E', description: 'Merchandise Exchange Only' },
  { key: 'T', description: '30 Days or Fewer' },
  { key: 'O', description: 'Other' },
];

// prettier-ignore
export const reasonsForApplying = [
  { key: 'Never Accepted Cards Before', description: 'Never accepted cards before' },
  { key: 'ProcessorChange', description: 'Processor change' },
];

// prettier-ignore
export const reasonsForApplyingToProcChange = [
  { reasonForApplyingValue: 'Never Accepted Cards Before', procChangeValue: 'NOT_NOW_PROC' },
  { reasonForApplyingValue: 'ProcessorChange', procChangeValue: 'PROC_CHANGE' },
];

// prettier-ignore
export const accountType = [
  { value: 'checking', name: 'Checking' },
  { value: 'saving', name: 'Saving' }
];

// prettier-ignore
export const accountPurpose = [
  { value: 'discount', name: 'Discount' },
  { value: 'fees', name: 'Fees' },
  { value: 'credits', name: 'Credits' },
  { value: 'chargebacks', name: 'Chargebacks' },
];

// prettier-ignore
export const companyTypes: { key: Registration['company_type']; description: string }[] = [
  { key: 'A', description: 'Association/Estate/Trust' },
  { key: 'G', description: 'Government (Federal/State/Local)' },
  { key: 'S', description: 'Individual/Sole Proprietor' },
  { key: 'F', description: 'Financial Institution' },
  { key: 'L', description: 'LLC (Limited-Liability Corporation)' },
  { key: 'E', description: 'Tax-Exempt Organization (501C)' },
  { key: 'P', description: 'Partnership' },
  { key: 'V', description: 'Private Corporation' },
  { key: 'B', description: 'Public Corporation' },
  { key: 'R', description: 'SEC-Registered Entity' },
];

// prettier-ignore
export const paymentProductTypes = [
  { key: 'in-person', plan: 'interchange0-15', description: 'In-Person (Terminal or POS integration)' },
  { key: 'mobile-reader', plan: 'interchange0-18', description: 'Mobile Reader' },
  { key: 'online', plan: 'interchange0-18', description: 'Online (Recurring Billing, Invoices)' },
  { key: 'shopping-cart', plan: 'interchange0-18', description: 'Online (Shopping Cart)' },
  { key: 'api', plan: 'interchange0-18', description: 'API' },
];

export const registrationIsConditionalApproved = (
  registration: Registration | null | undefined,
): boolean => {
  return (
    registration?.underwriting_status === 'APPROVED' &&
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    (registration?.underwriting_substatuses?.length! > 0 ||
      registration.underwriting_substatus?.length > 0)
  );
};

export const merchantIsConditionalApproved = (merchant: Merchant): boolean => {
  return (
    merchant?.underwriting_status === 'APPROVED' &&
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    merchant?.underwriting_substatuses?.length! > 0
  );
};

export const isSoleProp = (
  registration: { company_type?: string } | null | undefined,
): boolean => {
  return registration?.company_type === 'S';
};

export const isGogurtSource = (
  registration: { registration_source?: string | null } | null | undefined,
): boolean => {
  return registration?.registration_source === 'gogurt';
};
